import { useEffect, useState } from "react";
import axios from "axios";
import { Youtube, Facebook, Instagram, Music2 } from "lucide-react";
import { API } from "@/lib/api";

const META = {
  youtube: { label: "YouTube", icon: Youtube },
  tiktok: { label: "TikTok", icon: Music2 },
  facebook: { label: "Facebook", icon: Facebook },
  instagram: { label: "Instagram", icon: Instagram },
};
const ORDER = ["youtube", "tiktok", "facebook", "instagram"];

export const SocialLinks = ({ variant = "footer", className = "" }) => {
  const [socials, setSocials] = useState(null);

  useEffect(() => {
    axios.get(`${API}/live`).then(({ data }) => setSocials(data.socials || {})).catch(() => {});
  }, []);

  if (!socials) return null;
  const active = ORDER.filter((k) => socials[k]);
  if (active.length === 0) return null;

  if (variant === "icons") {
    return (
      <div className={`flex items-center gap-3 ${className}`} data-testid="social-links-icons">
        {active.map((k) => {
          const Icon = META[k].icon;
          return (
            <a
              key={k}
              href={socials[k]}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-icon-${k}`}
              aria-label={META[k].label}
              className="text-zinc-400 hover:text-green transition-colors"
            >
              <Icon size={20} />
            </a>
          );
        })}
      </div>
    );
  }

  return (
    <div className={className} data-testid="social-links">
      <p className="label mb-5">Follow The Movement</p>
      <div className="flex flex-wrap gap-3">
        {active.map((k) => {
          const Icon = META[k].icon;
          return (
            <a
              key={k}
              href={socials[k]}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-link-${k}`}
              className="btn-fill flex items-center gap-2 border border-[#1a1a1a] hover:border-green text-white px-5 py-2.5 rounded-full font-sub text-sm"
            >
              <Icon size={17} /> {META[k].label}
            </a>
          );
        })}
      </div>
    </div>
  );
};
